import React, { useMemo } from 'react';

import { Container, NavigationScroll, useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';

import { SEARCHKIT_HITS_PER_PAGE_ALL_CONTENT_AUTOSUGGEST, SCREEN_WIDE } from '../../config/constants';
import NavbarMenu from '../../implementations/Menu/NavbarMenu';
import {
  DrawerMenu,
  MegaMenu,
  SearchAllContent,
  SiteLogo,
} from '../../components';

import './style.scss';

const Header: React.FC = () => {
  const { width } = useWindowDimensions();
  const isMobile = useMemo(() => width < SCREEN_WIDE, [width]);

  return (
    <header className="SiteHeader__wrapper">
      <NavigationScroll>
        <MegaMenu menuId="main">
          <div className="SiteHeader">
            <Container>
              <div className="SiteHeader__inner">
                <SiteLogo isLarge={!isMobile} />

                <div className="SiteHeader__main-menu">
                  {isMobile ? (
                    <DrawerMenu>
                      {(closeDialog) => (
                        <>
                          <DrawerMenu.Menu menuId="main" onClickMenuLink={() => closeDialog()} />
                          <NavbarMenu />
                        </>
                      )}
                    </DrawerMenu>
                  ) : (
                    <div className="SiteHeader__main-menu__content">
                      <NavbarMenu />
                      <MegaMenu.TopMenu />
                    </div>
                  )}
                </div>

                <SearchAllContent className="SiteHeader__searchbar" hitsPerPage={SEARCHKIT_HITS_PER_PAGE_ALL_CONTENT_AUTOSUGGEST} onlyFetchWithQuery>
                  <SearchAllContent.SearchBarAutosuggest type="secondary" />
                </SearchAllContent>
              </div>
            </Container>
          </div>

          <MegaMenu.Overlay>
            <MegaMenu.SubMenu maxLevel={3} />
          </MegaMenu.Overlay>
        </MegaMenu>
      </NavigationScroll>
    </header>
  );
};

export default Header;
